import type {
  UseGetVendorMaterialStockItemDetailsParams,
  UseGetVendorMaterialStockItemDetailsQueryKey,
} from './types';

export const getUseGetVendorMaterialStockItemDetailsQueryKey = (
  params: UseGetVendorMaterialStockItemDetailsParams,
): UseGetVendorMaterialStockItemDetailsQueryKey => [
  'vendors',
  'material_stock_item',
  params,
];
